import { createFileRoute } from "@tanstack/react-router";
import OurPromise from "@/pages/OurPromise";

const URL = "https://www.homeapproach.com/our-promise";
const TITLE = "Our Promise | Home Approach";
const DESC = "Seven commitments: you choose every professional, no pay-to-play, rewards for your progress, and your information stays yours.";

export const Route = createFileRoute("/our-promise")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://www.homeapproach.com/" },
          { "@type": "ListItem", position: 2, name: "Our Promise", item: URL },
        ],
      }),
    }],
  }),
  component: OurPromise,
});
